export default ({page,totalPages,setPage}) => {
    return (
        <div className={'activities-pagination'}>
            { page != 1 && <i onClick={()=>setPage(page-1)} class="fa-solid fa-chevron-left"></i> }

            { Array.apply(null, Array(parseInt(totalPages))).map( (x, i) => { 
                return <span onClick={()=>setPage(i+1)} >{i+1}</span>; 
            }) }

            { page < totalPages && <i onClick={()=>setPage(page+1)} class="fa-solid fa-chevron-right"></i> }
        </div>
    )
}